// extracted by mini-css-extract-plugin
export default {"textarea":"ProdutosInfo_textarea__NG2-A"};